<div
  #carouselContainer
  class="carousel{{ isVerticalDirection(orientation) ? '-vertical' : '' }}"
  tabindex="0"
>
  <ul
    #carouselList
    class="carousel-list"
    role="listbox"
    [style.flex-direction]="flexDirection"
    [style.height]="'100%'"
  >
    <li
      #carouselSlide
      *ngFor="let slide of slidesList"
      class="carousel-slide"
      [class.allow-pan-y]="!isVerticalDirection(orientation)"
      role="option"
      [style.width]="calculateWidthOfSlide()"
      [style.padding]="calculatePaddingOfSlide()"
      [style.height]="calculateHeightOfSlide()"
      [style.min-height]="slideMinHeight"
      (panleft)="onPan($event, carouselSlide)"
      (panright)="onPan($event, carouselSlide)"
      (pandown)="onPan($event, carouselSlide)"
      (panup)="onPan($event, carouselSlide)"
      (panend)="onPanEnd($event, carouselSlide)"
      (pancancel)="onPanEnd($event, carouselSlide)"
    >
      <ng-container [ngTemplateOutlet]="slide.templateRef"></ng-container>
    </li>
  </ul>

  <button
    *ngIf="!hideArrows"
    mat-icon-button
    type="button"
    tabindex="-1"
    [color]="color"
    [disabled]="!loop && currentIndex == 0"
    (click)="previous()"
  >
    <mat-icon
      *ngIf="iconOverrides?.arrowBack; else defaultArrowBack"
      [svgIcon]="iconOverrides.arrowBack"
    ></mat-icon>
    <ng-template #defaultArrowBack>
      <mat-icon>{{
        isVerticalDirection(orientation)
          ? 'keyboard_arrow_up'
          : 'keyboard_arrow_left'
      }}</mat-icon>
    </ng-template>
  </button>

  <button
    *ngIf="!hideArrows"
    mat-icon-button
    type="button"
    tabindex="-1"
    [color]="color"
    [disabled]="!loop && currentIndex == slidesList.length - 1"
    (click)="next()"
  >
    <mat-icon
      *ngIf="iconOverrides?.arrowForward; else defaultArrowForward"
      [svgIcon]="iconOverrides.arrowForward"
    ></mat-icon>
    <ng-template #defaultArrowForward>
      <mat-icon>{{
        isVerticalDirection(orientation)
          ? 'keyboard_arrow_down'
          : 'keyboard_arrow_right'
      }}</mat-icon>
    </ng-template>
  </button>

  <div
    *ngIf="!hideIndicators"
    class="carousel-indicators"
    tabindex="-1"
    [style.flex-direction]="flexDirection"
  >
    <button
      *ngFor="let i of generateListOfIndicatorButton()"
      type="button"
      tabindex="-1"
      mat-mini-fab
      [color]="color"
      [disabled]="i == currentIndex"
      (click)="slideTo(i)"
      (focus)="carouselContainer.focus()"
    ></button>
  </div>
</div>
